if (
  process.env.NODE_ENV === "production"
  // process.env.NODE_ENV === "development"
) {
  console.log = function () {};
  console.info = function () {};
  console.warn = function () {};
  console.error = function () {};
  console.debug = function () {};
}
